import { Component, Input } from '@angular/core';

/**
 * DGA digital stamp (Unified Code criterion 11): the bilingual "registered government website" statement with
 * the DGA registration number, linked to its certificate page when the URL is configured. The parent renders it
 * only when a registration number exists; the component never invents one.
 */
@Component({
  selector: 'app-digital-stamp',
  templateUrl: './digital-stamp.component.html',
})
export class DigitalStampComponent {
  @Input() registrationNumber: string | null | undefined;
  @Input() certificateUrl: string | null | undefined;

  get hasNumber(): boolean {
    return !!this.registrationNumber?.trim();
  }

  get hasCertificateUrl(): boolean {
    return !!this.certificateUrl?.trim();
  }
}
